import router from './router'
import store from './store'
// import { Message } from 'element-ui'
import NProgress from 'nprogress' // Progress 进度条
import 'nprogress/nprogress.css'// Progress 进度条样式
import { getToken } from '@/utils/auth' // 验权
import { isWechat } from '@/utils/validate'
const ua = navigator.userAgent.toLowerCase()

const whiteList = ['/login', '/m/login', '/authredirect', '/register', '/forgot', '/userActivateSuccess', '/userActivateFailure', '/schedule']// 不重定向白名单
router.beforeEach((to, from, next) => {
  NProgress.start() // 开启Progress
  if (getToken()) { // 判断是否有token
    if (to.path === '/login' || to.path === '/register' || to.path === '/forgot') {
      next({ path: '/' })
      NProgress.done()
    } else if (to.path === '/m/login') {
      next({ path: '/m/home' })
      NProgress.done()
    } else {
      store.dispatch('GetUserInfo').then(res => { // 拉取user_info
        let status = res.data.data.status
        let teacherId = res.data.data.id
        if (isWechat(ua)) {
          next()
        } else {
          if (status === 10) {
            next({
              path: '/userAuth'
            })
          } else if (status === 2) {
            next({
              path: '/userInfo',
              query: {
                teacherid: teacherId
              }
            })
          } else if (status === 3) {
            next({ path: '/userAuthSuccess' })
          } else if (status === 4) {
            next({
              path: '/userAuthFailure',
              query: {
                teacherid: teacherId
              }
            })
          } else {
            if (to.path === '/userInfo' || to.path === '/userAuthSuccess' || to.path === '/userAuthFailure') {
              next({ path: '/' })
            } else {
              next()
            }
          }
        }
      }).catch(() => {
        store.dispatch('FedLogOut').then(() => {
          // Message.error('login check failed')
          if (isWechat(ua)) {
            next({ path: '/m/login' })
          } else {
            next({ path: '/login' })
          }
        })
      })
      next()
    }
  } else {
    if (whiteList.indexOf(to.path) !== -1) { // 在免登录白名单，直接进入
      next()
    } else {
      if (isWechat(ua)) {
        next({ path: '/m/login' })
      } else {
        next('/login') // 否则全部重定向到登录页
      }
      NProgress.done() // router在hash模式下 手动改变hash 重定向回来 不会触发afterEach 暂时hack方案 ps：history模式下无问题，可删除该行！
    }
  }
})

router.afterEach(() => {
  NProgress.done() // 结束Progress
})

const defaultTitle = 'BingoClass'
router.beforeEach((to, from, next) => {
  document.title = to.meta.title ? to.meta.title : defaultTitle
  next()
})


// WEBPACK FOOTER //
// ./src/permission.js